import { render, staticRenderFns } from "./TheConfirmationDialog.vue?vue&type=template&id=2b7d2b9a"
import script from "./TheConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./TheConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports